module.exports = __webpack_public_path__ + "assets/lessons/pl/lesson3/pages/lesson_3_06.pdf";